import React, { Component } from "react";
import DupontButton from "../../components/DupontButton";

class PlantsRender extends Component {
  invokeParentMethod = (e) => {
    e?.stopPropagation();
    // Set a global flag so AgTable rowClickHandler ignores this click
    window.isTableCellAction = true;
    if (this.props.context && this.props.context.handleReferenceRowClick) {
      this.props.context.handleReferenceRowClick({ data: this.props.node.data });
    }
    // Reset the flag after a short delay
    setTimeout(() => {
      window.isTableCellAction = false;
    }, 0);
  };

  render() {
    return (
      <div style={{ margin: 2}}>
        <DupontButton
          onClick={this.invokeParentMethod}
        >
          Show Plants
        </DupontButton>
      </div>
    );
  }
}

export default PlantsRender;
